import React from 'react';
// グローバル CSS のクラス名を使用

function GridButton({ isGridVisible, setIsGridVisible }) {
    const handleClick = () => {
        setIsGridVisible(prev => !prev);
        // console.log("GridBTN was pushed");
        // console.log(isGridVisible);
      };

  return (
    <button
      onClick={handleClick}
      className="btn btn--small"  // スタイルを適用
    >
      {isGridVisible ? 'グリッドを消す' : 'グリッドを表示する'}
    </button>
  );
}

export default GridButton;